import { Box, Grid, ResponsiveContext } from 'grommet'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

type ActionItem = {
  id: string
  label: string
  to?: string
  onClick?: () => void
  Icon?: React.FC<any>
  bgClass?: string
  disabled?: boolean
}

type Props = {
  items: ActionItem[]
  columns?: string[]
}

export const QuickActions = ({ items, columns = ['auto', 'auto'] }: Props) => {
  const size = useContext(ResponsiveContext)
  const computedColumns = size === 'small' ? ['100%'] : columns

  return (
    <Box>
      <Grid columns={computedColumns} gap="12px">
        {items.map(item => {
          const disabled = !!item.disabled

          const contentClass = `flex items-center gap-4 rounded-lg border border-[#E7E7E7] bg-white p-4 ${
            disabled ? 'cursor-not-allowed opacity-60' : ''
          }`

          const iconWrapperClass = `flex h-10 w-10 items-center justify-center rounded-md ${
            disabled ? 'filter grayscale opacity-60' : ''
          }`

          const labelClass = `text-sm font-medium ${disabled ? 'text-[#9CA3AF]' : 'text-[#111827]'}`

          const Content = disabled ? (
            <div aria-disabled="true" className={contentClass}>
              <div className={iconWrapperClass}>{item.Icon ? <item.Icon /> : null}</div>
              <div className={labelClass}>{item.label}</div>
            </div>
          ) : (
            <div className={contentClass}>
              <div className={iconWrapperClass}>{item.Icon ? <item.Icon /> : null}</div>
              <div className={labelClass}>{item.label}</div>
            </div>
          )

          if (item.to) {
            if (disabled) {
              return (
                <div aria-disabled="true" className="no-underline" key={item.id}>
                  {Content}
                </div>
              )
            }
            return (
              <Link className="no-underline" key={item.id} onClick={item.onClick} to={item.to}>
                {Content}
              </Link>
            )
          }

          return (
            <button
              className="text-left w-full"
              disabled={disabled}
              key={item.id}
              onClick={disabled ? undefined : item.onClick}
              type="button"
            >
              {Content}
            </button>
          )
        })}
      </Grid>
    </Box>
  )
}

export default QuickActions
